import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowInTopLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowInTopLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3.50011 2.43945L9.50011 8.43945V3.00011H11.0001V11.0001L3.00011 11.0001L3.00011 9.50011L8.43945 9.50011L2.43945 3.50011L3.50011 2.43945ZM13.0001 6.00011H22.0001V22.0001H6.00011V13.0001H7.50011V20.5001H20.5001V7.50011H13.0001V6.00011Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowInTopLeft;
